import { styled } from "@acko-tech/building-blocks.ui.common";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 16px;
  border-radius: var(--B-radius-16px, 16px);
  border: 1px solid #FDDFC1;
  background: linear-gradient(78deg, #FFE9D9 -92.23%, #FFF 134.02%);
  align-items: center;
  gap: 16px;
  box-sizing: border-box;
  ${(props) => props.styles}
`;

export const IconContainer = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
`;

export const TextContainer = styled.div`
  color: var(--Neutral-N600, #040222);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
